import { render } from "./ModalAddRegularTopUp.vue?vue&type=template&id=5657fe61&scoped=true"
import script from "./ModalAddRegularTopUp.vue?vue&type=script&lang=js"
export * from "./ModalAddRegularTopUp.vue?vue&type=script&lang=js"

import "./ModalAddRegularTopUp.vue?vue&type=style&index=0&id=5657fe61&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5657fe61"]])

export default __exports__